document.addEventListener('DOMContentLoaded', function() {
    var buyButtonWrapper = document.querySelector('.buy-qty-wrapper');
    var stickyWrapper = document.createElement('div');
    stickyWrapper.classList.add('sticky-buy-button-wrapper');

    // Clone the existing buy button wrapper without the ID
    var stickyBuyButtonWrapper = buyButtonWrapper.cloneNode(true);
    stickyBuyButtonWrapper.querySelector('.product-form__submit').removeAttribute('id');
    stickyWrapper.appendChild(stickyBuyButtonWrapper);
    document.body.appendChild(stickyWrapper);

    // Intersection Observer to toggle visibility of sticky button
    new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if(entry.isIntersecting) {
                document.body.classList.add('sticky-wrapper-visible');
            } else {
                document.body.classList.remove('sticky-wrapper-visible');
            }

        });
    }, { threshold: 1 }).observe(buyButtonWrapper);
    // Add event listeners to both the original and cloned buttons
    var originalSubmitButton = document.querySelector('.buy-qty-wrapper .product-form__submit');
    stickyBuyButtonWrapper.querySelector('.product-form__submit').addEventListener('click', function(event) {
        event.preventDefault(); // Prevent form submission
        originalSubmitButton.click(); // Trigger the original button click
    });
});